import Vue from 'vue';
import { Model } from '@vuex-orm/core';

const fetchInit = {
  isFetched: false,
  isFetching: false,
  fetchError: null,
};

export default class BaseModel extends Model {
  static state() {
    return {
      fetching: {},
    };
  }

  static getFetchStatus(key) {
    if (!this.getModelState().fetching[key]) {
      this.commit((state) => {
        Vue.set(state.fetching, key, { ...fetchInit });
      });
    }
    return this.getModelState().fetching[key];
  }

  static getModelState() {
    return this.store().state.entities[this.entity];
  }

  static async handleFetching(callback, key) {
    this.commit((state) => {
      Vue.set(state.fetching, key, { ...fetchInit, isFetching: true });
    });
    try {
      return await callback.call(this);
    } catch (e) {
      this.commit((state) => {
        state.fetching[key] = {
          ...state.fetching[key],
          fetchError: e.message,
        };
      });
      return e;
    } finally {
      this.commit((state) => {
        state.fetching[key] = { ...state.fetching[key], isFetched: true, isFetching: false };
      });
    }
  }
}
